module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.590ce0d2.png";